import { render } from "./MatiereList.vue?vue&type=template&id=4a533974&scoped=true"
import script from "./MatiereList.vue?vue&type=script&lang=js"
export * from "./MatiereList.vue?vue&type=script&lang=js"

import "./MatiereList.vue?vue&type=style&index=0&id=4a533974&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a533974"],['__file',"resources/js/pages/MatiereList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a533974"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a533974', __exports__)) {
    console.log('reload')
    api.reload('4a533974', __exports__)
  }
  
  module.hot.accept("./MatiereList.vue?vue&type=template&id=4a533974&scoped=true", () => {
    console.log('re-render')
    api.rerender('4a533974', render)
  })

}


export default __exports__